import * as React from 'react';
import isEqual from 'react-fast-compare';
import { Seat } from '../../../classes/seat';
import { SeatingOption } from '../../../classes/seating-option';
import { IAppSettingsModel } from '../../../reducers/fetch-settings-reducer';
import SeatInfoOptions from './seat-info-options';

export interface ISeatInfoOptionsContainerProps {
    seat: Seat;
    appSettingsModel: IAppSettingsModel;
    onSelectSeatingOption: (seatingOptions: SeatingOption[], groupId: string) => void;
    selectedSeatingOptions: Array<SeatingOption>;
    requestingSeatView: boolean;
    isGAZone?: boolean;
}

class SeatInfoOptionsContainer extends React.Component<ISeatInfoOptionsContainerProps, any>{
    static defaultProps = {
        isGAZone: false
    }

    shouldComponentUpdate(nextProps: ISeatInfoOptionsContainerProps) {
        return !isEqual({ seat: this.props.seat, selectedSeatingOptions: this.props.selectedSeatingOptions },
            { seat: nextProps.seat, selectedSeatingOptions: nextProps.selectedSeatingOptions })
    }

    render() {
        return (<SeatInfoOptions {...this.props}
            seatingOptionGroup={this.props.seat.seatingOptionGroup}
            requestingSeatView={this.props.requestingSeatView}
        />);
    }
}

export default SeatInfoOptionsContainer;